import { OcapiError } from '../../../../types/ocapi-error';
import { getResponseErrorCode } from '../../../../utils/get-response-error-code';
/**
 * @deprecated
 * In order to enable Strong Customer Authentication for subscription payments, this operation now requires authenticating a payment card for the future recurring subscription.
 *
 * - date: 2023-06-16
 */
export var SetFutureRecurringSubscriptionErrorCodeV1;
(function (SetFutureRecurringSubscriptionErrorCodeV1) {
    SetFutureRecurringSubscriptionErrorCodeV1[SetFutureRecurringSubscriptionErrorCodeV1["SubscriptionBillingOptionNotFound"] = 31000] = "SubscriptionBillingOptionNotFound";
    SetFutureRecurringSubscriptionErrorCodeV1[SetFutureRecurringSubscriptionErrorCodeV1["SubscriptionBillingOptionNotRecurring"] = 31001] = "SubscriptionBillingOptionNotRecurring";
    SetFutureRecurringSubscriptionErrorCodeV1[SetFutureRecurringSubscriptionErrorCodeV1["CurrentSubscriptionDoesNotExist"] = 31002] = "CurrentSubscriptionDoesNotExist";
    SetFutureRecurringSubscriptionErrorCodeV1[SetFutureRecurringSubscriptionErrorCodeV1["CurrentSubscriptionFrozen"] = 31003] = "CurrentSubscriptionFrozen";
    SetFutureRecurringSubscriptionErrorCodeV1[SetFutureRecurringSubscriptionErrorCodeV1["CurrentSubscriptionNonVistaPayment"] = 31004] = "CurrentSubscriptionNonVistaPayment";
    SetFutureRecurringSubscriptionErrorCodeV1[SetFutureRecurringSubscriptionErrorCodeV1["FutureSubscriptionCannotBeSet"] = 31005] = "FutureSubscriptionCannotBeSet";
    SetFutureRecurringSubscriptionErrorCodeV1[SetFutureRecurringSubscriptionErrorCodeV1["PrimaryPaymentCardNotFound"] = 31006] = "PrimaryPaymentCardNotFound";
})(SetFutureRecurringSubscriptionErrorCodeV1 || (SetFutureRecurringSubscriptionErrorCodeV1 = {}));
/**
 * @deprecated
 * In order to enable Strong Customer Authentication for subscription payments, this operation now requires authenticating a payment card for the future recurring subscription.
 *
 * - date: 2023-06-16
 */
export class SetFutureRecurringSubscriptionErrorV1 extends OcapiError {
    constructor(errorCode) {
        const message = `Failed to select future recurring subscription. API error code ${errorCode}: ${SetFutureRecurringSubscriptionErrorCodeV1[errorCode]}`;
        super(errorCode, message);
    }
}
export async function getSetFutureRecurringSubscriptionErrorV1(error) {
    const errorCode = await getResponseErrorCode(error);
    return errorCode && Object.values(SetFutureRecurringSubscriptionErrorCodeV1).includes(errorCode)
        ? new SetFutureRecurringSubscriptionErrorV1(errorCode)
        : error;
}
//# sourceMappingURL=set-future-recurring-subscription-error.js.map